export const validationTypes = {
    REQUIRE: "require",
    EMAIL: "email",
    PASSWORD: "password",
    PERCENTAGE: "percentage",
    GRADINGPOINT: "gradingPoint",
    PHONENUMBER: "phoneNumber",
    COMPARE: "compare",
    DISTINICT: "distinct",
    NUMBER: "number",
    UNIQUEIDENTIFIER: "uniqueIdentifier",
    MAXLENGTH: "maxLength",
    MINLENGTH: "minLength",
    MAXPROSPECTS: "maxProspects",
    MINENDDATE: "minEndDate",
    MAXSUM: "maxSum",
    VALIDEIN: "validEIN",
    APAARID: "apaarId",
    VALIDPHONE: "validPhone",
    VALIDFAX: "validFax",
    VALIDZIPCODE: "validZipCode",
    WEBSITE: "website",
    ONLYTEXT: "onlyText",
    UNIQUENAME: "uniqueName",
    FILE: "file",
    IMAGE: "image",
    MAXDATE: "maxDate",
    MINDATE: "minDate",
    MASKFORMAT: "maskFormat",
}